
import React from 'react'
import { Outlet } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import FloatingContactButton from './FloatingContactButton'
import RemoteSupportButton from './RemoteSupportButton'

interface LayoutProps {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      <FloatingContactButton />
      <RemoteSupportButton />
    </div>
  )
}

export default Layout
